"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoveableDrawable = exports.CollectionModelDrawable = exports.InsightMarkerDetectionClass = void 0;
exports.isInsightOffsetDetectionClass = isInsightOffsetDetectionClass;
exports.isInsightMarkerDetectionClass = isInsightMarkerDetectionClass;
var tslib_1 = require("tslib");
var math_1 = require("../../../math");
var capture_1 = require("../../capture");
/**
 * Insight detection classes which are rendered as marker drawables.
 */
var InsightMarkerDetectionClass;
(function (InsightMarkerDetectionClass) {
    InsightMarkerDetectionClass["ZeroOffset"] = "zero_offset";
    InsightMarkerDetectionClass["NineFeetMarker"] = "nine_feet_marker";
    InsightMarkerDetectionClass["SixFeetMarker"] = "six_feet_marker";
    InsightMarkerDetectionClass["ThreeFeetMarker"] = "three_feet_marker";
    InsightMarkerDetectionClass["Streetlight"] = "streetlight";
    InsightMarkerDetectionClass["Transformer"] = "transformer";
    InsightMarkerDetectionClass["Pole_top"] = "pole_top";
    InsightMarkerDetectionClass["Wire"] = "wire";
    InsightMarkerDetectionClass["Guy_wire"] = "guy_wire";
    InsightMarkerDetectionClass["Riser"] = "riser";
    InsightMarkerDetectionClass["Cutout"] = "cutout";
    InsightMarkerDetectionClass["Capacitor"] = "capacitor";
})(InsightMarkerDetectionClass || (exports.InsightMarkerDetectionClass = InsightMarkerDetectionClass = {}));
var insightOffsetClassDetections = [
    InsightMarkerDetectionClass.ZeroOffset,
    InsightMarkerDetectionClass.NineFeetMarker,
    InsightMarkerDetectionClass.SixFeetMarker,
    InsightMarkerDetectionClass.ThreeFeetMarker
];
/**
 * Check if the given insight detection class is one of the base or base offset types.
 */
function isInsightOffsetDetectionClass(className) {
    return insightOffsetClassDetections.includes(className);
}
/**
 * Check if the given string is one of the known insight marker detection classes.
 */
function isInsightMarkerDetectionClass(className) {
    return Object.values(InsightMarkerDetectionClass).includes(className);
}
/**
 * A drawable represents one or more visualizations to display on a capture.
 * Also called an "annotation" or a "measurement" elsewhere.
 *
 * All drawables implement Point, however the (x,y) coordinate can refer to different things;
 * for example a Label Point is the top-left corner of the label,
 * and a Marker Point is the target coordinate that the marker is drawn over.
 */
var CollectionModelDrawable = /** @class */ (function () {
    function CollectionModelDrawable(collectionModelDrawableState, drawableId) {
        this.id = drawableId;
        this.drawableState = collectionModelDrawableState;
        // Add this drawable to the drawableState
        if (this.drawableState.drawables.has(this.id)) {
            throw new Error("Tried to overwrite existing drawable with id: ".concat(this.id));
        }
        this.drawableState.drawables.set(this.id, this);
    }
    Object.defineProperty(CollectionModelDrawable.prototype, "collection", {
        get: function () {
            return this.drawableState.collection;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawable.prototype, "captureId", {
        get: function () {
            return this.drawableState.captureId;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawable.prototype.getVector = function () {
        return new math_1.Vector(this.x, this.y);
    };
    CollectionModelDrawable.prototype.getPointInBounds = function (x, y) {
        var capture = this.drawableState.capture;
        if (!capture) {
            return { x: x, y: y };
        }
        return {
            x: Math.min(capture.resolution.width, Math.max(0, x)),
            y: Math.min(capture.resolution.height, Math.max(0, y))
        };
    };
    Object.defineProperty(CollectionModelDrawable.prototype, "isDeletable", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawable.prototype, "isUserMeasurement", {
        /**
         * The drawable was created by the user, or is an approved insight detection.
         */
        get: function () {
            return !this.isInsightMeasurement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawable.prototype, "collectionHasBase", {
        get: function () {
            return !!this.drawableState.base;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Remove the drawable.
     * This will also unlink any linked fields, and remove any associated drawables such as attached labels or markers.
     */
    CollectionModelDrawable.prototype.remove = function () {
        this.drawableState.drawables.delete(this.id);
    };
    CollectionModelDrawable.prototype._equals = function (other) {
        return this.id === other.id;
    };
    return CollectionModelDrawable;
}());
exports.CollectionModelDrawable = CollectionModelDrawable;
var MoveableDrawable = /** @class */ (function (_super) {
    tslib_1.__extends(MoveableDrawable, _super);
    function MoveableDrawable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MoveableDrawable.prototype.isOnLeftSide = function () {
        var _a, _b;
        return this.x < ((_b = (_a = this.drawableState.capture) === null || _a === void 0 ? void 0 : _a.resolution.width) !== null && _b !== void 0 ? _b : capture_1.DEFAULT_CAPTURE_SIZE.width) / 2;
    };
    MoveableDrawable.prototype.isOnRightSide = function () {
        return !this.isOnLeftSide();
    };
    return MoveableDrawable;
}(CollectionModelDrawable));
exports.MoveableDrawable = MoveableDrawable;
//# sourceMappingURL=drawable.js.map